const regexes: Record<string, RegExp> = {
  // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
  email: /[\w!#$%&'*+\-\/=?\^_`{|}~]+(\.[\w!#$%&'*+\-\/=?\^_`{|}~]+)*@((([\-\w]+\.)+[a-zA-Z]{2,62})|(([0-9]{1,3}\.){3}[0-9]{1,3}))/
}

export { regexes }
